<template>
    <section class="pageSection" >
        <sync-loader v-show="loading" class="load-spinner" :loading="loading" :size="30" :sizeUnit="'px'"></sync-loader>
        <transition name="fade" mode="out-in" @beforeLeave="beforeLeave" @enter="enter" @afterEnter="afterEnter">
            <div v-if="test && attemp" style="">
                <h1>Test del curso</h1>
                <!--                <p>Dispones de 25 minutos para realizar el test. Dispones de los intentos que necesites.</p>-->
                <div class="form-vue">
                    <div class="form-group-vue" v-for="question in attemp.questions" v-bind:key="question.id">
                        <div class="question">{{question.text}}</div>
                        <div class="questionOptions">
                            <ul>
                                <li v-for="option in question.options" v-bind:key="option.id">
                                    <input type="radio" :id="`${option.id}`" :value="option.id"
                                           v-model="question.response">
                                    <label :for="`${option.id}`">{{option.text}}</label>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="form-group-vue"></div>
                    <div class="form-group-vue">
                        <button class="btn btn-success btn-block btn-lg" @click="finishTest">Finalizar el test</button>
                    </div>
                </div>

            </div>
        </transition>
    </section>
</template>

<script>
    /* eslint-disable */
    import {mapState} from 'vuex'
    import FloatLabel from "./elements/FloatLabel";

    const uuidv4 = require('uuid/v4');

    export default {
        name: 'test',
        components: {
            FloatLabel
        },
        computed: mapState(['courses', 'testEnd', 'test','attemp']),
        watch: {
            testEnd: function (newVal) {
                this.testEnded()
            }
        },
        data() {
            return {
                loading: false,
                emailJson: null
                // test: null
            }
        },
        mounted() {
            window.addEventListener('beforeunload', (event) => {
                event.returnValue = `Are you sure you want to leave?`;
            });

            if (!this.test) {
                this.$router.push({
                    name: 'certificateStart',
                    params: {courseSlug: this.courses[0].slug, token: this.$route.params.token}
                })
            }
            //TODO: postIntent
            if (this.test) {
                this.$store.dispatch({
                    type: 'postAttemp',
                    data: {testId: this.test.id, attemp: {id: uuidv4(), user: this.$route.params.token}}
                })
                    .then(()=>{
                        this.$gtm.trackEvent({
                            event: 'academy.accessTest', // Event type [default = 'interaction'] (Optional)
                            category: 'academy',
                            action: 'test_access',
                            label: 'Acceso al test',
                            value: 0,
                            // noninteraction: false // Optional
                        });
                    })

                    .catch(console.error)
            }
        },
        methods: {
            testEnded() {
                this.finishTest()
            },
            finishTest() {
                this.loading = true;
                this.$store.dispatch({type:'patchAttemp',data:{test:this.test,attemp:this.attemp}})
                    .then(()=>{
                            this.getAttemp();
                            window.removeEventListener('beforeunload', (event) => {
                                // event.returnValue = `Are you sure you want to leave?`;
                        });
                    })
                    .then(()=>{
                        this.$gtm.trackEvent({
                            event: 'academy.finishedTest', // Event type [default = 'interaction'] (Optional)
                            category: 'academy',
                            action: 'test_finished',
                            label: 'Test terminado',
                            value: 0,
                            // noninteraction: false // Optional
                        });
                    })
                    .catch((error)=>{console.log(error)})
                // this.startTest();

            },
            getAttemp(){
            //    todo: Obtener attemp para ver resultado.
                this.$store.dispatch({type:'getAttemp',data:{test:this.test,attemp:this.attemp}}).then((data)=>{
                    if (data.id){
                        if (data.status === 'pass') {
                            this.emailJson = {user: data.user, test: data.test, attemp: data.id, tag: 'certificate'};
                            this.sendEmail();
                        }
                        this.loading = false;
                        this.$router.push({
                            name: 'certificate',
                            params: {idTest: this.courses[0].id, idAttemp: data.id}
                        })
                    }
                });
            },
            send(){
                let res = this.$store.dispatch({type:'postUserSendEmail',data:this.emailJson});
                this.loading = false;
                return res
            },
            sendEmail: async function(){
                let result = await this.send();
                return result

            },
            beforeLeave(element) {
                this.prevHeight = getComputedStyle(element).height;
            },
            enter(element) {
                const {height} = getComputedStyle(element);

                element.style.height = this.prevHeight;

                setTimeout(() => {
                    element.style.height = height;
                });
            },
            afterEnter(element) {
                element.style.height = 'auto';
            },
        }
    }
</script>

<style lang="scss">
    .text-center {
        text-align: center;
    }

    .form-vue .form-group-vue {
        margin-bottom: 2em;
    }

    .question {
        font-size: 1.1em;
        font-weight: bold;
        margin-bottom: 0.5em;
    }

    .questionOptions {
        ul {
            list-style: none;
            padding-left: 1em;
            li,input,label{
                cursor: pointer;
            }
            li{
                margin-bottom: 0.5em;
            }
        }
    }
    .countBackground{
        display: block;
        height: 10px;
        top: 80px;
    }
    @media all and (max-width: 600px){
        .countBackground{
            top: 98px;
        }
        .header.test{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            .logo-menu-button{
                width: auto;
                margin-bottom: 0;
            }
        }
    }
</style>
